angular.module('workflow.app')
  .filter 'removeunderscore', () ->
    (input) ->
      input.replace(/_/g, ' ')
